<template>
  <v-toolbar fixed>
    <v-slide-x-transition>
      <v-toolbar-side-icon v-if="$route.name === 'matching/pivots'" @click="toggleSidebar" />
    </v-slide-x-transition>
    <v-toolbar-title>Matching</v-toolbar-title>
    <v-toolbar-breadcrumbs class="ml-3" />
    <v-spacer />
    <v-toolbar-match-ranking-button key="ranking" />
    <!-- A button to go to the view to see the QMPs or the pivots depending on the route that it is -->
    <v-slide-x-transition mode="out-in">
      
      <!-- Button to go the created QMPs -->
      <v-btn v-if="inPivotsView" @click="goToQmpsView" color="purple" dark key="go-to-qmps">
        <v-icon>done_all</v-icon>
        <span class="ml-2">QMPs creados</span>
      </v-btn>
      <v-btn v-if="inQmpsView" @click="goToPivotsView" color="pink" dark key="go-to-pivots">
        <v-icon>compare</v-icon>
        <span class="ml-2">Pivotes</span>
      </v-btn>
    </v-slide-x-transition>
    <!-- The settings of the module -->
    <v-toolbar-settings-menu />
  </v-toolbar>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState } = createNamespacedHelpers("matching");

import VToolbarBreadcrumbs from "./components/Breadcrumbs";
import VToolbarSettingsMenu from "../settings-menu/Layout";
import VToolbarMatchRankingButton from "./components/ToolbarMatchRankingButton";

export default {
  components: {
    VToolbarBreadcrumbs,
    VToolbarSettingsMenu,
    VToolbarMatchRankingButton
  },
  computed: {
    ...mapState(["sidebarVisible"]),
    inPivotsView() {
      return this.$route.name === "matching/pivots";
    },
    inQmpsView() {
      return this.$route.name === "matching/qmps";
    }
  },
  methods: {
    ...mapMutations(["setSidebarVisible"]),
    goToPivotsView() {
      this.$router.push({ name: "matching/pivots" });
    },
    goToQmpsView() {
      this.$router.push({ name: "matching/qmps" });
    },
    toggleSidebar() {
      this.setSidebarVisible(!this.sidebarVisible);
    }
  }
};
</script>